<template>
  <div class="app-layout__footer">
    <slot>
      <app-footer></app-footer>
    </slot>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter'

export default {
  name: 'AppLayoutFooter',
  components: {
    AppFooter
  }
}
</script>
